// Formats a product variant's size+unit into a compact human-readable label.
// Examples: {size:"100",unit:"ml"} → "100 ml" · {size:"1",unit:"kg"} → "1 kg"
// Falls back gracefully if variant already has the unit embedded in size (legacy).
export const formatVariant = (v) => {
  if (!v) return '';
  const size = String(v.size ?? '').trim();
  if (!size) return v.unit || '';
  // Legacy "10ml" rows: unit already inside size
  if (/[a-zA-Z]/.test(size)) return size.replace(/(\d)([a-zA-Z])/, '$1 $2');
  const unit = (v.unit || 'ml').trim();
  return `${size} ${unit}`;
};

// Variant key helper for cart item identity (product + variant)
export const variantKey = (v) => `${v.size}|${v.unit || ''}`;
